<script setup lang="ts">
import { ref } from 'vue';

import TableFoldBtn from '@/components/btns/TableFoldBtn.vue';

export interface Props {
  title?: string;
  defaultOpen?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  title: '',
  defaultOpen: true,
});

const isOpen = ref(props.defaultOpen);
</script>

<template>
  <section :class="$style.addressBookPanel" data-testid="addressBookPanel">
    <div :class="$style.header">
      <h3 :class="$style.title">{{ props.title }}</h3>
      <div :class="$style.headerRight">
        <slot name="actions" />
        <TableFoldBtn
          :is-open="isOpen"
          :aria-label="isOpen ? 'Collapse' : 'Expand'"
          @click="isOpen = !isOpen"
        />
      </div>
    </div>
    <div v-show="isOpen" :class="$style.body">
      <slot />
    </div>
  </section>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';

.addressBookPanel {
  border: 1px solid colors.$color-gray-200;
  border-radius: 8px;
  background-color: colors.$color-white;
  overflow: hidden;
}
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    padding: 0.75rem 0.75rem 0.75rem 1.25rem;
  }
    .title {
      margin: 0;
      font-size: 1.125rem;
      font-weight: 600;
      color: colors.$color-text-primary;
    }
    .headerRight {
      display: flex;
      align-items: center;
      gap: 0.25rem;
    }
  .body {
    border-top: 1px solid colors.$color-gray-200;
  }
</style>
